/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AppliesToType {
    REGISTRATION_FEE = 'registration_fee',
    FEES = 'fees',
    ALL = 'all',
}
